import {
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
} from '@mui/material';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import CustomButton from '../elements/CustomButton';
import InputField from '../elements/InputField';

const UserForm = ({ onSubmit, type, user }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const initialValues =
    type === 'edit'
      ? {
          first_name: user?.first_name || '',
          last_name: user?.last_name || '',
          email: user?.email || '',
          phone_number: user?.phone_number || '',
        }
      : {
          first_name: user?.first_name || '',
          last_name: user?.last_name || '',
          email: user?.email || '',
          phone_number: user?.phone_number || '',
          password: '',
        };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
          first_name: Yup.string()
            .max(255)
            .required('First Name is required')
            .matches(/^[a-zA-Z\s]*$/, 'Invalid characters'),
          last_name: Yup.string()
            .max(255)
            .matches(/^[a-zA-Z\s]*$/, 'Invalid characters')
            .required('Last Name is required'),
          email: Yup.string()
            .email('Must be a valid email')
            .max(255)
            .required('Email is required'),
          password:
            type !== 'edit' &&
            Yup.string()
              .required('Password is required')
              .min(8, 'Password must be at least 8 characters')
              .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
                'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
              ),
          phone_number: Yup.string()
            .required('Phone Number is required')
            .matches(
              /^[0-9]{10}$/,
              'Invalid phone number (10 digits required)'
            ),
        })}
        onSubmit={onSubmit}>
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Stack spacing={1}>
                  <InputField
                    label="First Name"
                    id="first_name"
                    type="text"
                    value={values.first_name}
                    name="first_name"
                    fullWidth
                    placeholder="First"
                    error={Boolean(touched.first_name && errors.first_name)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={1}>
                  <InputField
                    label="Last Name"
                    id="last_name"
                    type="text"
                    value={values.last_name}
                    name="last_name"
                    fullWidth
                    placeholder="Last"
                    error={Boolean(touched.last_name && errors.last_name)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={12}>
                <Stack spacing={1}>
                  <InputField
                    label="Email Address"
                    id="email"
                    type="email"
                    value={values.email}
                    name="email"
                    fullWidth
                    disabled={type === 'edit' ? true : false}
                    placeholder="Enter email address"
                    error={Boolean(touched.email && errors.email)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={12}>
                <Stack spacing={1}>
                  <InputField
                    label="Phone No."
                    id="phone_number"
                    type="tel"
                    name="phone_number"
                    fullWidth
                    placeholder="Enter phone number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone_number}
                    error={touched.phone_number && Boolean(errors.phone_number)}
                    helperText={touched.phone_number && errors.phone_number}
                  />
                </Stack>
              </Grid>

              {type !== 'edit' && (
                <Grid item xs={12} md={12}>
                  <Stack spacing={1}>
                    <InputField
                      label={'Password'}
                      fullWidth
                      error={Boolean(touched.password && errors.password)}
                      id="password"
                      type={showPassword ? 'text' : 'password'}
                      value={values.password}
                      name="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            size="large">
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                      placeholder="********"
                      inputProps={{}}
                    />
                  </Stack>
                </Grid>
              )}

              {errors.submit && (
                <Grid item xs={12}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Grid>
              )}
              <Grid item xs={12}>
                <CustomButton
                  buttonLabel={type === 'edit' ? 'Update' : 'Create'}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default UserForm;
